var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "sc-fjdhpX llkNcE",
    name: "filter",
    color: "#414141",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.607 15.502a1.77 1.77 0 0 1 3.382 0h13.512a.499.499 0 1 1 0 .996H11.992a1.77 1.77 0 0 1-3.383 0h-2.11a.499.499 0 1 1 0-.996h2.108zm.924.476a.506.506 0 0 1 0 .034c.013.4.33.722.736.74.427.016.782-.307.8-.702V16a.765.765 0 0 0-.735-.752c-.426-.016-.782.307-.8.702v.028zm13.862-5.73a1.77 1.77 0 0 1-3.382 0H6.499a.499.499 0 1 1 0-.997h13.509a1.77 1.77 0 0 1 3.383 0h2.11a.499.499 0 1 1 0 .996h-2.108zm-.924-.477a.506.506 0 0 1 0-.034.765.765 0 0 0-.736-.74c-.427-.016-.782.307-.8.701v.051a.765.765 0 0 0 .735.752c.426.016.782-.307.8-.702V9.77zm.924 12.978a1.77 1.77 0 0 1-3.382 0H6.499a.499.499 0 1 1 0-.996h13.509a1.77 1.77 0 0 1 3.383 0h2.11a.499.499 0 1 1 0 .996h-2.108zm-.924-.476a.506.506 0 0 1 0-.034.765.765 0 0 0-.736-.74c-.427-.016-.782.307-.8.702V22.251a.765.765 0 0 0 .735.752c.426.016.782-.307.8-.701v-.03z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.cf9e61e562bbb15702e74d2763f6bf42.svg";
export { ForwardRef as ReactComponent };